import moment from "moment";

export const formatRs = (value) =>
  `Rs ${Number(value || 0).toLocaleString("en-PK", { maximumFractionDigits: 2 })}`;

export const formatRsTable = (value) =>
  Number(value || 0).toLocaleString("en-PK", { maximumFractionDigits: 2 });

export const isLoanApproved = (hrStatus) => hrStatus === "approved";

export const formatIssueDateDisplay = (issueDate, hrStatus) => {
  if (!isLoanApproved(hrStatus) || !issueDate) {
    return "—";
  }
  return moment(issueDate).format("DD-MM-YYYY");
};

export const toIssueDateInputValue = (issueDate) =>
  issueDate ? moment(issueDate).format("YYYY-MM-DD") : "";

export const formatAmountPaidDisplay = (value, hrStatus) =>
  isLoanApproved(hrStatus) ? formatRs(value) : "—";

export const formatAmountLeftDisplay = (value, hrStatus) =>
  isLoanApproved(hrStatus) ? formatRs(value) : "—";

export const formatAmountPaidTableDisplay = (value, hrStatus) =>
  isLoanApproved(hrStatus) ? formatRsTable(value) : "—";

export const formatAmountLeftTableDisplay = (value, hrStatus) =>
  isLoanApproved(hrStatus) ? formatRsTable(value) : "—";

/** HR list: status at index 6. Employee list: status at index 5. */
export const getLoanRowStatus = (tableMeta, statusIndex = 6) =>
  tableMeta?.rowData?.[statusIndex];
